import { Modal, ModalFooter, ModalHeader } from "react-bootstrap"
import React from "react"
import { useState } from "react"
import { useRenameCourseMutation } from "../api/courses"
import { showNotification } from "../../shared/helpers"

export const EditNameModal = ({show, setShow, course}) => {
  // Added this early return because I am rendering this modal for every course
  // Any extra computation will be felt
  const [name, setName] = useState(course.name)
  const [saveName] = useRenameCourseMutation()

  if(!show)
    return null

  const handleSave = async () => {
    await saveName({url: course.updateNameUrl, newName: name}).unwrap()
    showNotification('Name changed succesfully')
    window.location.reload()
  }

  const handleChange = (event) => {
    setName(event.target.value)
  }

  return (
    <Modal show={show} onHide={() => setShow(false)} className="center-modal" backdrop='static'>
      <div className="courses-modal-title-container">
        <div className="courses-modal-title">
          {window.I18n.t('courses.bootstrap_course_table.rename')}
        </div>
      </div>
      <Modal.Body className='add-margin-bottom-10 add-margin-top-10 courses-small-modal-body-container'>
        <div className="add-margin-bottom-5 bold">{window.I18n.t('courses.master_roster_courses.new_name')} </div>
        <input
          autoFocus
          value={name}
          onChange={handleChange}
          type="text"
          className="search-select-input"
        />
      </Modal.Body>
      <ModalFooter>
        <div className="courses-modal-buttons-container">
          <button onClick={() => setShow(false)} className="cancel_action small grey button btsp_small_white_button">{window.I18n.t('courses.cancel')}</button>
          <button onClick={handleSave} className="next_action small orange button btsp_small_orange_button">{window.I18n.t('courses.save')}</button>
        </div>
      </ModalFooter>
    </Modal>
  )
}